import React, {useState, useEffect} from 'react'
import { useTranslation } from "react-i18next";
import {GetAlertsComponent, setObjectByPath, getConstantTextFields,validateConstantValues, translateType} from "./utils"
import { getDatetimeFormatted } from '../../utils';
import InputMask from "react-input-mask";
import moment from 'moment'
import _ from 'lodash'
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Tooltip from "@material-ui/core/Tooltip";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import HelpIcon from "@material-ui/icons/Help";

let this_box_type = "datetime"

function getStringPattern(value){
    if (value.length === 10) return "DD/MM/YYYY"
    else return "DD/MM/YYYY HH:mm:ss"
}

function returnVisualPattern (value) {
    return (moment(value, moment.ISO_8601,true).isValid() 
    ?
    moment(value).format(getStringPattern(value))
    :
    value)
}

export function ConstantDatetimeBox (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleConfigurationOpen} = props
    let {handleNodeRemove} = props

    let displayValue = returnVisualPattern(node.node.properties.value)

    return (
        <div>
            {!read_only ? 
                <div style={{display:"flex", alignItems: "center"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t(displayValue)}
                        {(node.node.alerts || []).length > 0?
                        <GetAlertsComponent alerts={node.node.alerts} />  : null} 
                    </div>
                    <IconButton style={{width: 32, height: 32}} aria-label="duplicate" onClick={() => props.handleNodeDuplication(node)}>
                        <ContentCopyIcon style={{width: 20, height: 20}} />
                    </IconButton>
                    <IconButton style={{width: 32, height: 32}} aria-label="close" onClick={() => handleNodeRemove(node)}>
                        <CloseIcon style={{width: 20, height: 20}} />
                    </IconButton>
                </div>
                :
                <div style={{display:"flex"}}>
                    <div style={{display:"flex", width:"100%", cursor:"pointer", margin: "auto 0px"}} onClick={() => handleConfigurationOpen(node)}>
                        {t(displayValue)}
                    </div>
                </div>
            }
        </div>
    )
}

export function ConstantDatetimeConfiguration (props) {
    const { t } = useTranslation();
    let {node} = props
    let {read_only} = props
    let {handleNodeChange} = props
    let {handleConfigurationClose} = props

    let standardTextField = getConstantTextFields(this_box_type)

    const [nodeState, setNodeState] = useState(node)

    useEffect(()=>{
        setNodeState(node)
    },[node])

    const handleNodeStateChange = (obj_key,value) => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node,obj_key,value)
        setNodeState(new_node)
    }

    const handleSave = () => {
        let new_node = _.cloneDeep(nodeState)
        setObjectByPath(new_node.node,"properties.value",getDatetimeFormatted(nodeState.node.properties.value))        
        handleConfigurationClose()
        handleNodeChange(new_node)
    }

    return (
        <div style={{flexGrow:"1", padding: "20px", display:"flex", flexDirection:"column"}}>
            <div style={{display: "flex"}}>
                <span className={["blueText", "subtitleSize", "labelSpace"].join(" ")}>{t("datetime_america_sao_paulo")}</span>
                <Tooltip title={<div className="tooltipText"><ul>{node.node.helperText.map((help,index) => (<li key={index}>{t(help)}</li>))}</ul></div>}>

                    <HelpIcon style={{fontSize: "14px", display:"flex", margin:"auto 5px"}}/>
                </Tooltip>
            </div>
            <div className="internalCardContainer" style={{display:"flex", flexDirection: "column"}}>
                <InputMask
                    style={{textAlign:"center", width:"80%", margin:"3px auto"}}
                    error={!validateConstantValues(this_box_type,getDatetimeFormatted(nodeState.node.properties.value))}
                    {...standardTextField.props}
                    value={returnVisualPattern(nodeState.node.properties.value)}
                    onChange={(e) => handleNodeStateChange("properties.value", e.target.value)}
                    InputProps={{
                        readOnly: read_only
                      }}
                />       
            </div>
            <div style={{display:"flex", margin: "auto auto 5px auto"}}>
                <div
                    className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                    style={{width:"120px"}}
                    onClick={handleConfigurationClose}
                >
                    {read_only ? "X" : t("discard")}
                </div>
                {!read_only && 
                <div
                    className={
                        validateConstantValues(this_box_type,getDatetimeFormatted(nodeState.node.properties.value))
                        ?
                        ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                        :
                        ["button", "standard", "normalText", "normalMediumSize","disabled"].join(" ")}
                    style={{width:"120px"}}
                    onClick={validateConstantValues(this_box_type,getDatetimeFormatted(nodeState.node.properties.value)) ? handleSave : null}
                >
                    {t("save")}
                </div>}     
            </div>
        </div>
    )
}

export class ConstantDatetimeBoxClass {
    constructor(rulesContext){
        this.rulesContext = rulesContext
    }
    validate(node){
        let put_error = false
        let alerts = []
        //Validate if node has no children
        if((node.node.children || []).length !== 0){
            put_error = true
            alerts.push("O nó de "+ translateType(this_box_type) +" não pode ter filhos")
        }
        //Validate value is not lenth 0
        if(!validateConstantValues(this_box_type,node.node.properties.value)){
            put_error = true
            alerts.push("Este nó deve ter uma data válida")
        }
        //Validate if parent is valid
        if (node.parentNode != null) {
            if(node.parentNode.on_error){
                put_error = true
                alerts.push("O nó superior está inválido")
            }
        }
        return {validated: !put_error, alerts: alerts}
    }

    getType(node){
        return this_box_type
    }
}